"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Timer {
    constructor(sec) {
        this.state = true;
        this.keys = [];
        // @ts-ignore
        this.id = null;
        this.start = () => {
            if (this.id !== null) {
                return;
            }
            this.id = setInterval(() => {
                this.state = true;
                this.keys = [];
                this.stop();
            }, this.sec * 1000);
        };
        this.stop = () => {
            if (this.id === null) {
                return;
            }
            clearInterval(this.id);
            this.id = null;
        };
        this.fetch = (key) => {
            const state = this.state || this.keys.indexOf(key) === -1;
            this.state = false;
            this.keys.push(key);
            if (state) {
                this.start();
            }
            return state;
        };
        this.sec = sec;
    }
}
exports.default = Timer;
//# sourceMappingURL=Timer.js.map